import React, {useState} from 'react';
import {useLocation, Link} from 'react-router-dom';

import {Collapse, ListGroup} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

const AccountSubmenu = ({nav, slug}) => {
    const location = useLocation()

    // -----------------------------------------------------------------------------------------------------------------

    const [collapseShow, setCollapseShow] = useState(location.pathname.includes(slug));

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <ListGroup.Item className={`pe-0 ps-2 py-3 bg-transparent border-0 d-flex align-items-center${collapseShow ? ' open' : ''}`} onClick={() => setCollapseShow(collapseShow => !collapseShow)}>
                {nav.icon}
                {nav.title}
                <IconFi.FiChevronLeft size={24} className="sw-1 ms-auto my-1 text-white text-opacity-18"/>
            </ListGroup.Item>
            <Collapse in={collapseShow}>
                <div className="border-bottom border-white-5">
                    <div className="pb-2">
                        {
                            nav.child.map((item, index) => {
                                return (
                                    <ListGroup.Item as={Link} to={item.to} className={`pe-0 ps-5 pb-2 bg-transparent border-0 d-flex align-items-center ${index === 0 ? 'pt-0' : 'pt-2'}`} key={item.id}>
                                        {item.title}
                                        <IconFi.FiChevronLeft size={24} className="sw-1 ms-auto my-1 text-white text-opacity-18"/>
                                    </ListGroup.Item>
                                )
                            })
                        }
                    </div>
                </div>
            </Collapse>
        </>
    )
}

export default AccountSubmenu;